import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

interface ButtonProposition {
  label: string;
  value: string;
  backgroundColor?: string;
}

@Component({
  selector: 'frg-multiple-choice',
  templateUrl: './multiple-choice.fragment.html',
  styleUrls: [
    './multiple-choice.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class MultipleChoiceFragment implements OnInit {

  public arrayPropositions: Array<ButtonProposition> = [];
  public header = '';
  public msgExplication = '';
  public msgQuestion = '';
  public options: MultipleChoiceOptions;
  private defaultOptions: MultipleChoiceOptions = {
    msgWrapperMaxWidth: '24.6rem'
  }

  @Output() public closeEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    if (!this.options) {
      this.options = this.defaultOptions;
    }
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeConfirmationModal(null);
  }

  public closeConfirmationModal(buttonValue: string | null): void {
    this.closeEmitter.emit(buttonValue);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}

export interface MultipleChoiceOptions {
  msgWrapperMaxWidth: string;
}
